<template>
  <!-- Customer Content Right Rail -->
  <div class="main-right-content d-flex flex-column">
    <v-container v-if="currentCustomer" class="main-center-middle pt-4 flex-grow-1">
      <div class="contact-photo text-center" v-if="customerId == null">
        <v-tooltip left v-if="!currentCustomer.isBusiness">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-account</v-icon>
          </template>
          <span>Person</span>
        </v-tooltip>
        <v-tooltip left v-if="currentCustomer.isBusiness">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-domain</v-icon>
          </template>
          <span>Company</span>
        </v-tooltip>
      </div>
      <div class="contact-info">
        <v-sheet
          v-on:click="editCustomerDetail"
          v-on:mouseover="$set(hoverCheck, 'customer-name', true)"
          v-on:mouseleave="$set(hoverCheck, 'customer-name', false)"
          class="contact-name"
        >
          <span>&nbsp; &nbsp;</span>
          {{ currentCustomer.fullName }}
          <v-icon :class="{ 'ui-icon-hide': !hoverCheck['customer-name'] }"
            >mdi-pencil</v-icon
          >
        </v-sheet>

        <!-- Contact Info -->
        <div class="customer-details-section">
          <v-sheet class="d-flex justify-space-between pa-2">
            <v-sheet class="customer-detail-type">Contact Info</v-sheet>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-sheet
                  v-on="on"
                  class="add-new"
                  @click="editContactInfo({ id: -1 })"
                  >+ add</v-sheet
                >
              </template>
              <span>Add Contact Info</span>
            </v-tooltip>
          </v-sheet>
          <v-sheet>
            <table class="detail-table">
              <tr
                v-on:mouseover="
                  $set(hoverCheck, 'contact-info-' + contactInfo.id, true)
                "
                v-on:mouseleave="
                  $set(hoverCheck, 'contact-info-' + contactInfo.id, false)
                "
                v-on:click="editContactInfo({ id: contactInfo.id })"
                :key="'contact-info-' + contactInfo.id"
                v-for="contactInfo in currentCustomer.contactInfos"
              >
                <td class="table-col-first-icon">
                  <v-icon v-if="contactInfo.label == 'mobile'"
                    >mdi-cellphone</v-icon
                  >
                  <v-icon v-else-if="contactInfo.label == 'home'"
                    >mdi-home</v-icon
                  >
                  <v-icon v-else-if="contactInfo.label == 'work'"
                    >mdi-office-building</v-icon
                  >
                  <v-icon v-else>mdi-phone</v-icon>
                </td>
                <td class="table-col-details">
                  <!-- <span
                    :class="{
                      'table-col-details-phone': contactInfo.type == 'phone'
                    }"
                    @click.stop="onClickContactInfo(contactInfo)"
                    >{{ contactInfo.detail }}</span
                  > -->
                  <span>{{ contactInfo.detail }}</span>
                </td>
                <td class="table-col-last-icon">
                  <v-icon>{{
                    hoverCheck["contact-info-" + contactInfo.id]
                      ? "mdi-pencil"
                      : !hoverCheck["contact-info-" + contactInfo.id] &&
                        contactInfo.receiveNotification
                      ? "mdi-bell-outline"
                      : ""
                  }}</v-icon>
                </td>
              </tr>
            </table>
          </v-sheet>
        </div>

        <!-- Addresses -->
        <div class="customer-details-section">
          <v-sheet class="d-flex justify-space-between mt-4 pa-2">
            <v-sheet class="customer-detail-type">Addresses</v-sheet>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-sheet v-on="on" class="add-new" @click="editAddress(-1)"
                  >+ add</v-sheet
                >
              </template>
              <span>Add Address</span>
            </v-tooltip>
          </v-sheet>
          <v-sheet>
            <table class="detail-table">
              <tr
                :key="'address-' + address.id"
                v-for="address in currentCustomer.addresses"
                v-on:mouseover="$set(hoverCheck, 'address-' + address.id, true)"
                v-on:mouseleave="
                  $set(hoverCheck, 'address-' + address.id, false)
                "
                v-on:click="editAddress(address.id)"
              >
                <td class="table-col-first-icon">
                  <v-icon v-if="address.type == 'office'"
                    >mdi-office-build</v-icon
                  >
                  <v-icon v-else-if="address.type == 'bill'">mdi-cash</v-icon>
                  <v-icon v-else-if="address.type == 'ship'">mdi-truck</v-icon>
                  <v-icon v-else-if="address.type == 'home'">mdi-home</v-icon>
                  <v-icon v-else>mdi-map-marker</v-icon>
                </td>
                <td class="table-col-details">
                  {{ address.address1 }}<br v-if="address.address1" />
                  {{ address.address2 }}<br v-if="address.address2" />
                  {{ address.city
                  }}<span v-if="address.city && address.state">,</span>
                  {{ address.state }} {{ address.postalCode }}
                </td>
                <td class="table-col-last-icon">
                  <v-icon>{{
                    hoverCheck["address-" + address.id] ? "mdi-pencil" : ""
                  }}</v-icon>
                </td>
              </tr>
            </table>
          </v-sheet>
        </div>

        <!-- Other Info -->
        <div class="customer-details-section">
          <v-sheet class="d-flex justify-space-between pa-2">
            <v-sheet class="customer-detail-type">Additional Info</v-sheet>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-sheet v-on="on" class="add-new" @click="editOtherInfo(-1)"
                  >+ add</v-sheet
                >
              </template>
              <span>Add Additional Info</span>
            </v-tooltip>
          </v-sheet>
          <v-sheet>
            <table class="detail-table">
              <tr
                :key="'other-info-' + otherInfo.id"
                v-on:mouseover="
                  $set(hoverCheck, 'other-info-' + otherInfo.id, true)
                "
                v-on:mouseleave="
                  $set(hoverCheck, 'other-info-' + otherInfo.id, false)
                "
                v-on:click="editOtherInfo(otherInfo.id)"
                v-for="otherInfo in currentCustomer.otherInfos"
              >
                <td class="custom-field-name">
                  {{ otherInfo.label }}
                </td>
                <td class="table-col-details">
                  {{
                    otherInfo.listItemId && otherInfo.label == "Source"
                      ? leadSources.filter(function(val) {
                          return val.id == otherInfo.listItemId;
                        })[0].name
                      : otherInfo.detail
                  }}
                </td>
                <td class="table-col-last-icon">
                  <v-icon>{{
                    hoverCheck["other-info-" + otherInfo.id] ? "mdi-pencil" : ""
                  }}</v-icon>
                </td>
              </tr>
            </table>
          </v-sheet>
        </div>
      </div>
    </v-container>
    <v-container v-else-if="currentHistoryItem">
      <v-sheet class="customer-detail-type">Attach to Customer</v-sheet>
      <main-search></main-search>
    </v-container>

    <!-- <v-btn
      v-if="$vuetify.breakpoint.smAndDown"
      elevation="2"
      fab
      class="mobile-customer-rail-switcher"
      @click="switchToCustomerDetail"
      ><v-icon>mdi-history</v-icon></v-btn
    > -->
    <div class="flex-shrink-0">
      <div class="history-actions my-4 pb-2" v-if="$vuetify.breakpoint.smAndDown">
        <v-btn
          small
          tile
          outlined
          color="primary"
          class="mx-2"
          v-if="currentCustomer && $vuetify.breakpoint.smAndDown"
          @click="switchToCustomerDetail"
          ><v-icon left>mdi-history</v-icon> Customer History</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
const MainSearch = () =>
  import(
    /* webpackChunkName: "components-global-MainSearch" */ `../global/MainSearch.vue`
  );

export default {
  name: "CustomerRightRail",
  components: {
    MainSearch
  },
  props: {
    customerId: Number
  },
  data: function() {
    return {
      hoverCheck: {},
      accountId: 0,
      contactInfoModalId: 0,
      contactInfoModalMsg: ""
    };
  },
  created() {},
  computed: {
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    currentCustomer() {
      let vueThis = this;
      if (vueThis.user && vueThis.user.currentCustomerId) {
        return vueThis.$store.getters["entities/customers/query"]()
          .withAllRecursive(2)
          .find(vueThis.user.currentCustomerId);
      } else if (vueThis.customerId > 0) {
        return vueThis.$store.getters["entities/customers/query"]()
          .withAllRecursive(2)
          .find(vueThis.customerId);
      } else {
        return null;
      }
    },
    customerSince() {
      if (this.currentCustomer) {
        return (
          "Customer since " +
          format(this.currentCustomer.customerStartDate, "M/d/y")
        );
      } else {
        return "";
      }
    },
    reviewSettingsConfig() {
      const tempSettings = this.$store.getters[
        "entities/bizReviewSettings"
      ]().first();
      return tempSettings ? tempSettings.config : {};
    },
    account() {
      return this.$store.getters["entities/accounts"]().first();
    },
    leadSources() {
      let leadSources = this.$store.getters["entities/listItems/query"]().get();
      return leadSources;
    },
    currentHistoryItem() {
      const historyItems =
        this.$parent.$parent.$parent.selectedCallNumber ||
        this.$parent.$parent.$parent.selectedChatId;
      return historyItems;
    }
  },
  methods: {
    // TODO remove when done
    async tester() {
      // TODO testing only
      this.$store.dispatch("entities/chats/hydrate", 0);
      this.$store.dispatch("entities/chats/fetchChatMessages", { chatId: 1 });

      /*this.$root.$children[0].showCustomerEditorModals = true;
      await this.$nextTick();
      let theContainer = this.$root.$children[0].$refs[
        "customer-editor-modals"
      ];
      theContainer.AppointmentModalId = -1;
      theContainer.CustomerId = this.currentCustomer.id;
      if (this.currentCustomer && this.currentCustomer.id > 0) {
        theContainer.AppointmentModalCustomerId = this.currentCustomer.id;
      }
      theContainer.showAppointmentFormModal = true;*/
    },
    switchToCustomerDetail() {
      this.$store.dispatch("entities/settings/update", {
        where: 1,
        data: {
          showCustomerDetail: false
        }
      });
    },
    iconForEditNotification() {},
    async editCustomerDetail() {
      let vueThis = this;
      this.$root.$children[0].showCustomerEditorModals = true;
      let timer = setInterval(function checkCustomerEditorModals() {
        vueThis.$root.$children[0].showCustomerEditorModals = true;
        if (
          vueThis.$root.$children[0].$refs["customer-editor-modals"] !=
          undefined
        ) {
          clearInterval(timer);
          let theContainer =
            vueThis.$root.$children[0].$refs["customer-editor-modals"];
          theContainer.CustomerId = vueThis.currentCustomer.id;
          theContainer.showCustomerDetailFormModal = true;
        }
      }, 100);
    },
    async editContactInfo({ id = -1, customerId, type, details }) {
      let vueThis = this;
      this.$root.$children[0].showCustomerEditorModals = true;
      let timer = setInterval(function checkCustomerEditorModals() {
        vueThis.$root.$children[0].showCustomerEditorModals = true;
        if (
          vueThis.$root.$children[0].$refs["customer-editor-modals"] !=
          undefined
        ) {
          clearInterval(timer);
          let theContainer =
            vueThis.$root.$children[0].$refs["customer-editor-modals"];
          theContainer.ContactInfoModalId = id;
          theContainer.ContactInfoType = type;
          theContainer.ContactInfoDetails = details;
          theContainer.CustomerId = customerId || vueThis.currentCustomer.id;
          theContainer.showContactInfoFormModal = true;
        }
      }, 100);
    },
    async editAddress(id) {
      let vueThis = this;
      this.$root.$children[0].showCustomerEditorModals = true;
      let timer = setInterval(function checkCustomerEditorModals() {
        vueThis.$root.$children[0].showCustomerEditorModals = true;
        if (
          vueThis.$root.$children[0].$refs["customer-editor-modals"] !=
          undefined
        ) {
          clearInterval(timer);
          let theContainer =
            vueThis.$root.$children[0].$refs["customer-editor-modals"];
          theContainer.AddressModalId = id;
          theContainer.CustomerId = vueThis.currentCustomer.id;
          theContainer.showAddressFormModal = true;
        }
      }, 100);
    },
    async editOtherInfo(id) {
      let vueThis = this;
      this.$root.$children[0].showCustomerEditorModals = true;
      let timer = setInterval(function checkCustomerEditorModals() {
        vueThis.$root.$children[0].showCustomerEditorModals = true;
        if (
          vueThis.$root.$children[0].$refs["customer-editor-modals"] !=
          undefined
        ) {
          clearInterval(timer);
          let theContainer =
            vueThis.$root.$children[0].$refs["customer-editor-modals"];
          theContainer.OtherInfoModalId = id;
          theContainer.CustomerId = vueThis.currentCustomer.id;
          theContainer.showOtherInfoFormModal = true;
          timer = null;
        }
      }, 100);
    },
    onClickContactInfo(contactInfo) {
      if (contactInfo.type == "phone") {
        // alert("testing " + contactInfo.id);
      } else {
        // this.editContactInfo(contactInfo.id);
      }
    }
  }
};
</script>

<style scoped lang="stylus">
.add-new:hover {
  cursor: pointer;
}
.main-right-content {
  flex-grow: 1;
  overflow-y: scroll;
  width: 100%;
}
.customer-details-section {
  margin-top: 1rem;
}
.customer-detail-type {
  font-weight: bold;
}
table {
  border-collapse: collapse;
}
.table-col-first-icon {
  text-align: right;
  padding: 0 2px 0 1rem;
}
td.custom-field-name {
  padding: 0 0 0 1rem;
  word-break: keep-all;
}
.table-col-last-icon {
  text-align: left;
  width: 99%;
  padding: 0;
}
.table-col-last-icon i {
  min-width: 1rem;
}
.table-col-details {
  white-space: nowrap;
  padding: .5rem 0.5rem;
}
.table-col-details-phone:hover {
  color: blue;
  text-decoration:underline
}
.table-col-first-icon i.mdi::before, .table-col-last-icon i.mdi::before {
  font-size: .9rem;
  color: rgba(0, 0, 0, 0.87);
}
.ui-icon-hide.mdi::before {
  color: white;
}
div.contact-name i {
  font-size: 1.2rem;

}
</style>
